import { Button, Dialog } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

interface IProps {
  handleCloseImageModal: () => void;
  imageModalOpen: boolean;
  handleImageChange: (e: any) => void;
  error: string;
  handleImageSubmit: () => void;
}

const MessageDialog: React.FC<IProps> = ({
  handleCloseImageModal,
  imageModalOpen,
  handleImageChange,
  error,
  handleImageSubmit
}) => {
  return (
    <Dialog onClose={handleCloseImageModal} open={imageModalOpen}>
      <input type="file" multiple={true} onChange={handleImageChange} />
      <br />
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <Button variant="contained" color="secondary" onClick={handleImageSubmit}>
        Upload
      </Button>
    </Dialog>
  );
};

const ErrorMessage = styled.p`
  color: red;
  padding: 0 10px;
`;

export default MessageDialog;
